import * as React from 'react';
import Draggable from 'react-draggable';
import { KnobContainer, Knob, KnobValue, KnobValuePlus, Label } from './styles.js';

const RentalPlanSelectorKnob = ({ currentPoint , knobPosition , pointAccentColors , handleDragStop , handleDragStart , dragHandler , isDraggable , isDragging , isLocked , isDisabled , hasPlusLabel  })=>{
    return /*#__PURE__*/ React.createElement(Draggable, {
        axis: "x",
        bounds: "parent",
        position: knobPosition,
        onDrag: dragHandler,
        onStart: handleDragStart,
        onStop: handleDragStop,
        disabled: !isDraggable
    }, /*#__PURE__*/ React.createElement(KnobContainer, {
        animated: !isDragging
    }, /*#__PURE__*/ React.createElement(Knob, {
        isPressed: isLocked,
        hasAccentColors: Boolean(currentPoint === null || currentPoint === void 0 ? void 0 : currentPoint.hasAccentColors),
        backgroundColor: (pointAccentColors === null || pointAccentColors === void 0 ? void 0 : pointAccentColors.backgroundColor) || "",
        isDisabled: isDisabled
    }, /*#__PURE__*/ React.createElement(KnobValue, {
        hasAccentColors: Boolean(currentPoint === null || currentPoint === void 0 ? void 0 : currentPoint.hasAccentColors),
        textColor: (pointAccentColors === null || pointAccentColors === void 0 ? void 0 : pointAccentColors.textColor) || "",
        isDisabled: isDisabled
    }, currentPoint === null || currentPoint === void 0 ? void 0 : currentPoint.value, hasPlusLabel && /*#__PURE__*/ React.createElement(KnobValuePlus, null, "+")), /*#__PURE__*/ React.createElement(Label, {
        hasAccentColors: Boolean(currentPoint === null || currentPoint === void 0 ? void 0 : currentPoint.hasAccentColors),
        textColor: (pointAccentColors === null || pointAccentColors === void 0 ? void 0 : pointAccentColors.textColor) || "",
        isDisabled: isDisabled
    }, currentPoint === null || currentPoint === void 0 ? void 0 : currentPoint.label))));
};

export { RentalPlanSelectorKnob };
